import request from '../utils/request';

/**   
 * api接口统一管理
 */

import {
    get,
    getHeader,
    post,
    postHeader,
    postUpload,
    postQuery,
    postExport,
    printFile,
    printCertificateFirst,
    printCertificateSecond,
    printLicense,
    printPersonCertificate,
    printMechanicalPictures,
    printLicenseZhengBen,
    copyPrintFileLicense,
    printLicenseFuBen,
    printCertificateZhengben,
    printCertificateFuben,
    printCertificateZhengfuben,
    printLicenseZhengFuBen
} from './http'

export const fetchData = query => {
    return request({
        url: './table.json',
        method: 'get',
        params: query
    });
};



export const todoData = () => {
    return request({
        url: './todoList.json',
        method: 'get'
    });
};
// 到期换证
export const endChange = p => post('/api/ctCertificateApply/examineCertificateTimeexpandSubmit', p);
// 登入
export const login = p => post('/api/login', p);
// 修改密码
export const updatePassword = p => post('/api/psPerson/updatePassword', p);

// 任务提醒数量
export const listTaskRemindNum = p => post('/api/listTaskRemindNum', p);


// 生产牌照号
export const getLicenseNumber = p => post('/api/homepage/getLicenseNumber', p);

// 查询牌照号前缀
export const getPrefixLicense = p => post('/api/bsCity/getCity', p);

//省市
export const listProvinceCitys = p => post('/api/bsProvince/listProvinceCitys', p);
// 省
export const listProvinces = p => post('/api/bsProvince/listProvinces', p);
// 市
export const listCitysByProvinceId = p => postQuery('/api/bsCity/listCitysByProvinceId', p);

// 省市县
export const listProvinceCityCountys = p => post('/api/bsProvince/listProvinceCityCountys', p);

// 图片上传

// 预约消息
//   		-分页查询
export const listAppointmentInformations = p => post('/api/psAppointmentInformation/listAppointmentInformations', p);
// 处理
export const changeStatus = (p, h) => postHeader('/api/psAppointmentInformation/changeStatus', p, h);
//分支机构管理
//          -新增保存
export const saveBranchOrganization = p => post('/api/psOrganization/saveBranchOrganization', p);
//   		-分页查询
export const listBranchOrganizations = p => post('/api/psOrganization/listBranchOrganizations', p);
//          -查看
export const getBranchOrganization = p => post('/api/psOrganization/getBranchOrganization', p);
//          -编辑保存
export const updateBranchOrganization = p => post('/api/psOrganization/updateBranchOrganization', p);
//          -删除
export const deleteBranchOrganization = p => post('/api/psOrganization/deleteBranchOrganization', p);



// 总部管理员管理
// 				-新增
export const saveHeadAdminPerson = p => post('/api/psOrganization/saveHeadAdminPerson', p);
// 				-分页查询
export const listHeadAdminPersons = p => post('/api/psOrganization/listHeadAdminPersons', p);
//              -编辑
export const updateHeadAdminPerson = p => post('/api/psOrganization/updateHeadAdminPerson', p);
//              -离职
export const quitHeadAdminPerson = (p, h) => postHeader('/api/psOrganization/quitHeadAdminPerson', p, h);
//              -查询
export const getHeadAdminPerson = (p, h) => postHeader('/api/psOrganization/getHeadAdminPerson', p, h);



// 机械厂商管理
//            -新增
export const saveManufacturerOrganization = p => post('/api/psOrganization/saveManufacturerOrganization', p);
// 				-分页查询
export const listManufacturerOrganizations = p => post('/api/psOrganization/listManufacturerOrganizations', p);
//              -删除
export const deleteManufacturerOrganization = (p, h) => postHeader('/api/psOrganization/deleteManufacturerOrganization', p, h);
//              -查询
export const getManufacturerOrganization = (p, h) => postHeader('/api/psOrganization/getManufacturerOrganization', p, h);
//              -编辑
export const updateManufacturerOrganization = p => post('/api/psOrganization/updateManufacturerOrganization', p);


// 机械厂商业务员管理
//               机械厂商下拉
export const listOrganizationComboVos = p => post('/api/psOrganization/listOrganizationComboVos', p);
//               -新增
export const saveManufacturerBusinessPerson = p => post('/api/psOrganization/saveManufacturerBusinessPerson', p);
// 				-分页查询
export const listManufacturerBusinessPersons = p => post('/api/psOrganization/listManufacturerBusinessPersons', p);
//              -离职
export const quitManufacturerBusinessPerson = (p, h) => postHeader('/api/psOrganization/quitManufacturerBusinessPerson', p, h);
//              -查询
export const getManufacturerBusinessPerson = (p, h) => postHeader('/api/psOrganization/getManufacturerBusinessPerson', p, h);
//              -编辑
export const updateManufacturerBusinessPerson = p => post('/api/psOrganization/updateManufacturerBusinessPerson', p);



//总部业务员管理
//               -新增
export const saveHeadBusinessPerson = p => post('/api/psOrganization/saveHeadBusinessPerson', p);
// 				-分页查询
export const listHeadBusinessPersons = p => post('/api/psOrganization/listHeadBusinessPersons', p);
//              -离职
export const quitHeadBusinessPerson = (p, h) => postHeader('/api/psOrganization/quitHeadBusinessPerson', p, h);
//              -查询
export const getHeadBusinessPerson = (p, h) => postHeader('/api/psOrganization/getHeadBusinessPerson', p, h);
//              -编辑
export const updateHeadBusinessPerson = p => post('/api/psOrganization/updateHeadBusinessPerson', p);


//工程机械牌照申请
export const checkLicenseNumberIsExist = p => postQuery('/api/mcLicenseApply/checkLicenseNumberIsExist', p);

//   			-分页查询
export const listLicenseApplys = p => post('/api/mcLicenseApply/listLicenseApplys', p);

//              -查看
export const getLicenseApply = p => postQuery('/api/mcLicenseApply/getLicenseApply', p);
//              -总部添加证书
export const savePcLicenseApply = p => post('/api/mcLicenseApply/savePcLicenseApply', p);
//             -车主变更or车辆变更
export const savePcMechanicsTransactionApply = p => post('/api/mcLicenseApply/savePcMechanicsTransactionApply', p);

// 车辆变更保存
export const savePcMechanicsTransactionApply1 = p => post('/api/mcLicenseApply/savePcMechanicsTransactionApply1', p);

export const updatePcLicenseApply = p => post('/api/mcLicenseApply/updatePcLicenseApply', p);

// 分支机构牌照审核中 -- 分支机构牌照审核 --  提交修改
export const updatePcLicenseApplySh = p => post('/api/mcLicenseApply/updatePcLicenseApplySh', p);
// 工程机械牌照审核
//				-牌照审核——分页 
export const listLicenseApplyExamines = p => post('/api/mcLicenseApply/listLicenseApplyExamines', p);
//  			-车辆变更审核+车主变更审核——分页
export const listMechanicsTransactionApplyExamines = p => post('/api/mcLicenseApply/listMechanicsTransactionApplyExamines', p);
//              -牌照修改审核——分页
export const listLicenseApplyUpdateExamines = p => post('/api/mcLicenseApply/listLicenseApplyUpdateExamines', p);
//              牌照审核 通过 or 退回
export const examineLicenseApply = p => post('/api/mcLicenseApply/examineLicenseApply', p);

export const examineLicenseApply1 = p => post('/api/mcLicenseApply/examineLicenseApply1', p);


// 				车辆变更+车主变更  通过 or 退回
export const examineMechanicsTransactionApply = p => post('/api/mcLicenseApply/examineMechanicsTransactionApply', p);
// 				车辆变更+车主变更  通过 or 退回
export const examineMechanicsTransactionApply1 = p => post('/api/mcLicenseApply/examineMechanicsTransactionApply1', p);

// 				牌照修改审核  通过 or 退回
export const examineLicenseApplyUpdate = p => post('/api/mcLicenseApply/examineLicenseApplyUpdate', p);
//              牌照审核-查看
export const getLicenseApplyExamine = p => postQuery('/api/mcLicenseApply/getLicenseApplyExamine', p);
//             车辆变更+车主变更-查看
export const getMechanicsTransactionApplyExamine = p => postQuery('/api/mcLicenseApply/getMechanicsTransactionApplyExamine', p);
//			   牌照修改审核-查看
export const getLicenseApplyUpdateExamine = p => postQuery('/api/mcLicenseApply/getLicenseApplyUpdateExamine', p);


//工程机械操作证书申请
//   			-分页查询
export const listCertificateApplys = p => post('/api/ctCertificateApply/listCertificateApplys', p);
//          操作证书申请&操作证书审核   -查看
export const getCertificateApply = (p, h) => postHeader('/api/ctCertificateApply/getCertificateApply', p, h);
// 			操作证书到期换证审核   -查看
export const getCertificateTimeexpandApply = (p, h) => postHeader('/api/ctCertificateApply/getCertificateTimeexpandApply', p, h);
//        总部  添加证书
export const savePcCertificateApply = p => post('/api/ctCertificateApply/savePcCertificateApply', p);
//        修改证书回显
export const getUpdatePcCertificateApply = (p, h) => postHeader('/api/ctCertificateApply/getUpdatePcCertificateApply', p, h);

//        修改证书
export const updatePcCertificateApply = p => post('/api/ctCertificateApply/updatePcCertificateApply', p);

// 删除操作证书申请
export const deleteCertificateApply = p => postQuery('/api/ctCertificateApply/deleteCertificateApply', p);

// 删除操作证书到期换证申请
export const deleteCertificateTimeexpandApply = p => postQuery('/api/ctCertificateApply/deleteCertificateTimeexpandApply', p);


//工程机械操作证书审核
//   			-审核分页查询
export const listCertificateApplyExamines = p => post('/api/ctCertificateApply/listCertificateApplyExamines', p);
//   			-到期换证分页查询
export const listCertificateTimeexpandApplyExamines = p => post('/api/ctCertificateApply/listCertificateTimeexpandApplyExamines', p);
//              -审核通过or回退
export const examineCertificateApply = p => post('/api/ctCertificateApply/examineCertificateApply', p);
//              -到期换证通过or回退
export const examineCertificateTimeexpandApply = p => post('/api/ctCertificateApply/examineCertificateTimeexpandApply', p);



//工程机械相关资讯维护
//             -分页查询
export const listConsults = p => post('/api/imConsult/listConsults', p);
//             -添加
export const saveConsult = p => post('/api/imConsult/saveConsult', p);
//             -查看
export const getConsult = (p, h) => postHeader('/api/imConsult/getConsult', p, h);
//             -删除
export const deleteConsult = (p, h) => postHeader('/api/imConsult/deleteConsult', p, h);
//   		   -编辑
export const updateConsult = p => post('/api/imConsult/updateConsult', p);


// 工程机械操作学习资料维护
//             -分页查询
export const listArticles = p => post('/api/bsArticle/listArticles', p);
//             -添加
export const saveArticle = p => post('/api/bsArticle/saveArticle', p);
//             -查看
export const getArticle = (p, h) => postHeader('/api/bsArticle/getArticle', p, h);
//             -删除
export const deleteArticle = p => postQuery('/api/bsArticle/deleteArticle', p);
//   		   -编辑
export const updateArticle = p => post('/api/bsArticle/updateArticle', p);


// 工程机械操作证书考试内容
//             -分页查询
export const listQuestions = p => post('/api/bsQuestion/listQuestions', p);
//             -添加
export const saveQuestion = p => post('/api/bsQuestion/saveQuestion', p);
//             -查看
export const getQuestion = (p, h) => postHeader('/api/bsQuestion/getQuestion', p, h);
//             -删除
export const deleteQuestion = p => postQuery('/api/bsQuestion/deleteQuestion', p);
//             -编辑
export const updateQuestion = p => post('/api/bsQuestion/updateQuestion', p);


// 分支机构牌证申请审批
//             -分页
export const listOrganizationLicenseApplyExamines = p => post('/api/psOrganizationLicenseApply/listOrganizationLicenseApplyExamines', p);
//             -添加
export const saveOrganizationLicenseApply = p => post('/api/psOrganizationLicenseApply/saveOrganizationLicenseApply', p);
//             -查看
export const getOrganizationLicenseApply = (p, h) => postHeader('/api/psOrganizationLicenseApply/getOrganizationLicenseApply', p, h);
//             -通过or回退
export const examineOrganizationLicenseApply = p => post('/api/psOrganizationLicenseApply/examineOrganizationLicenseApply', p);
// 总部牌证申请删除
export const deleteLicenseApplys = (p, h) => postHeader('/api/psOrganizationLicenseApply/delOrganizationLicenseApply', p, h);
// 分支机构牌证申请查看
//            -分页
export const listOrganizationLicenseApply = p => post('/api/psOrganizationLicenseApply/listOrganizationLicenseApply', p);
// 邮寄状态
export const changeMailStatus = (p, h) => postHeader('/api/psOrganizationLicenseApply/changeMailStatus', p, h);

// 删除牌照申请
export const deleteLicenseApply = p => postQuery('/api/mcLicenseApply/deleteLicenseApply', p);



// 牌照起始号
export const getCityStartNumber = (p, h) => postHeader('/api/psOrganizationLicenseApply/getCityStartNumber', p, h);
// 维护分支机构牌照对应关系
// 				-分页查询
export const listCitys = p => post('/api/bsCity/listCitys', p);
//              -查看
export const getCity = (p, h) => postHeader('/api/bsCity/getCity', p, h);
//              -编辑
export const updateCity = p => post('/api/bsCity/updateCity', p);
//              -删除
export const deletePrefixLicense = p => postQuery('/api/bsCity/deletePrefixLicense', p);

// 货源信息维护
// 				-分页查询
export const listLivingDemands = p => post('/api/imLivingDemand/listLivingDemands', p);
//              -下架
export const deleteLivingDemand = p => postQuery('/api/imLivingDemand/deleteLivingDemand', p);

// 二手车信息维护
// 				-分页查询
export const listUsedCars = p => post('/api/imUsedCar/listUsedCars', p);
//              -下架
export const deleteUsedCar = p => postQuery('/api/imUsedCar/deleteUsedCar', p);


// 打印文件 - 操作证书
export const printFileCertificateFirst = p => printCertificateFirst(p);
// 打印文件 - 操作证书
export const printFileCertificateSecond = p => printCertificateSecond(p);
// 打印操作证书 - 个人证件照片 
export const printFilePersonCertificate = p => printPersonCertificate(p);
// 打印操作证书 - 正本
export const printFileCertificateZhengben = p => printCertificateZhengben(p);
// 打印操作证书 - 副本
export const printFileCertificateFuben = p => printCertificateFuben(p);
// 操作证正副本打印
export const printFileCertificateZhengfuben = p => printCertificateZhengfuben(p);


// 打印文件 - 牌照
export const printFileLicense = p => printLicense(p);
// 分支牌照查看（设备档案打印）
export const copyPrintFileLicens = p => copyPrintFileLicense(p);
// 打印牌照 - 机械图片
export const printFileMechanicalPictures = p => printMechanicalPictures(p);
// 打印牌照 - 设备登记证 - 正本
export const printFileLicenseZhengBen = p => printLicenseZhengBen(p);
// 打印牌照 - 设备登记证 - 副本
export const printFileLicenseFuBen = p => printLicenseFuBen(p);
// 打印牌照 - 设备登记证 - 正副本
export const printFileLicenseZhengFuBen = p => printLicenseZhengFuBen(p);
// 牌照打印
export const printLicenseApply = p => postQuery('/api/mcLicenseApply/printLicenseApply', p);

// 操作证书打印改变打印状态
export const printCertificateApplys = p => postQuery('/api/ctCertificateApply/printCertificateApplys', p);



// 分支机构菜单下的api
//分页
export const listBranchBusinessPersons = p => post('/api/psOrganization/listBranchBusinessPersons', p);
//添加
export const saveBranchBusinessPerson = p => post('/api/psOrganization/saveBranchBusinessPerson', p);
//查看
export const getBranchBusinessPerson = (p, h) => postHeader('/api/psOrganization/getBranchBusinessPerson', p, h);
//编辑
export const updateBranchBusinessPerson = p => post('/api/psOrganization/updateBranchBusinessPerson', p);

// 分支机构信息
export const getBranchData = (p, h) => postHeader('/api/psOrganization/getBranchData', p, h);
export const updateBranchData = p => post('/api/psOrganization/updateBranchData', p);

//获取统计图表数据
export const getEchartData = p => post('/api/statistics/sum', p);